import {GetOrderOrderItemResponse} from '../../types/orderResponse';
import {OrderItem} from '../../models/orderItem';

const convertOrderResponseItemToOrderItem = (
    item: GetOrderOrderItemResponse
): OrderItem => {
    return {
        sku: item.sku,
        description: item.name,
        qty: item.qty,
        qtyRefunded: item.qtyRefunded,
    };
};

export default convertOrderResponseItemToOrderItem;
